var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:'sequence',staticClass:"sbolSequence"},[_c('div',{staticClass:"scrollable"},[_c('div',{staticClass:"sequence",domProps:{"innerHTML":_vm._s(this.showSelection(_vm.sequence,this.getStart(),this.getEnd()))}})])])}
var staticRenderFns = []

export { render, staticRenderFns }